// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"19ff4422b12bf55841ec","678":"9cd91a85a6b6737be8d2"}[chunkId] + ".js";
};